import React from 'react';

import theme from '@/styles/theme';

import { IconCommentFill, IconEye, IconHeartRoundFill } from '../icon';

type ColorType = 'gray' | 'white';

type IconType = 'heart' | 'eye' | 'talkbox';

type Props = {
  color?: ColorType;
  icon: IconType;
  children?: React.ReactNode;
};

const iconName = {
  heart: {
    gray: <IconHeartRoundFill size={12} opacity={0.5} />,
    white: (
      <IconHeartRoundFill size={12} color={theme`colors.apps.coreGrayWhite`} />
    ),
  },
  eye: {
    gray: (
      <IconEye
        size={12}
        opacity={0.5}
        color={theme`colors.apps.coreGrayBlack`}
      />
    ),
    white: <IconEye size={12} color={theme`colors.apps.coreGrayWhite`} />,
  },
  talkbox: {
    gray: (
      <IconCommentFill
        size={12}
        opacity={0.5}
        color={theme`colors.apps.coreGrayBlack`}
      />
    ),
    white: (
      <IconCommentFill size={12} color={theme`colors.apps.coreGrayWhite`} />
    ),
  },
};

const COLOR_CLASS: Record<ColorType, string> = {
  gray: 'text-apps-brandGray100',
  white: 'text-apps-coreGrayWhite',
};

export default function Overview({ color = 'gray', icon, children }: Props) {
  return (
    <div
      className={`inline-flex items-center gap-1 text-xs font-normal leading-[130%] tracking-[-0.24px] ${COLOR_CLASS[color]}`}
    >
      {iconName[icon][color]}
      {children}
    </div>
  );
}
